export const QUALIFICATION_STATUS_LABELS = {
  pending_review: "Brouillon (à valider)",
  entity_found: "Trouve",
  raw_lead: "Brut",
  qualifiable: "Qualifiable",
  to_enrich: "A enrichir",
  qualified: "Qualifie",
  priority: "Prioritaire",
  contacted: "Contacte",
  excluded: "Exclu",
  archived: "Archive",
};

export const PRIORITY_LABELS = {
  high: "Haute",
  medium: "Moyenne",
  low: "Basse",
  none: "Aucune",
};

export const APPROACHABILITY_LABELS = {
  approachable_now: "Approchable maintenant",
  enrich_before_contact: "A enrichir avant contact",
  watchlist: "A surveiller",
  exclude: "A exclure",
};

export const MOMENTUM_LABELS = {
  hot: "Chaud",
  warm: "Tiede",
  cold: "Froid",
  unknown: "Inconnu",
};

export function getQualificationStatusLabel(value) {
  return QUALIFICATION_STATUS_LABELS[value] || value || "-";
}

export function getPriorityLabel(value) {
  return PRIORITY_LABELS[value] || value || "-";
}

export function getApproachabilityLabel(value) {
  return APPROACHABILITY_LABELS[value] || value || "-";
}

export function getMomentumLabel(value) {
  return MOMENTUM_LABELS[value] || value || "-";
}
